import { computed, Ref } from "@vue/composition-api";
import { asString } from "./common";

export interface RegExAttr {
  regex: Readonly<Ref<boolean>>;
  regexError: Readonly<Ref<boolean>>;
}

export const regExValidator = (
  inputRef: Ref<string | number>,
  inputValueDirty: Ref<boolean>,
  regex: RegExp
): RegExAttr => {
  const regexValidate = computed(() => {
    const value = asString(inputRef.value);
    return regex.test(value);
  });
  return {
    regex: regexValidate,
    regexError: computed(() => !regexValidate.value && inputValueDirty.value)
  };
};
